<template>
  <div class="pa-4">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ApprovalFlow',
};
</script>